import React, { useEffect } from "react";
import {useHistory, useLocation} from "react-router-dom";
import { useCaseToken } from "./CaseTokenProvider";
import {useAuth0} from "@auth0/auth0-react";
import LinearProgress from "@mui/material/LinearProgress";
import {getTheme} from "../../app/helper";

const Callback = () => {

    const history = useHistory();
    const location = useLocation();
    const { getAccessTokenSilently } = useAuth0();
    const { setCaseAccessToken, setCaseTokenExpiry, setCaseRefreshToken, setCaseTokenError } = useCaseToken();
    const theme = getTheme()
    const progressBarColour =  theme?.palette?.secondary?.main || "#808080"

    useEffect(() => {

        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        const state = params.get('state');
        const error = params.get('error');
        const originalPath= localStorage.getItem('originalPath'); //for redirect

        const handleCaseCallback = async () => {

            console.log ('CaseCallback - handleCaseCallback')
            // console.log ('CaseCallback - params', params)

            const storedState = localStorage.getItem('state');
            const originalPath= localStorage.getItem('originalPath'); //for redirect

            // console.log ('CaseCallback - code=', code)
            // console.log ('CaseCallback - state=', state)
            // console.log ('CaseCallback - storedState', storedState)

            if (!code || state !== storedState) {
                console.error('Invalid state or missing code in case callback');
                setCaseTokenError('Invalid state or missing code in case callback ' + error)
                history.replace(originalPath)
                return;
            }

            try {
                const now = Math.floor(Date.now() / 1000); //seconds
                const url = window.REACT_APP_SECURITY_API_BASE_URL + window.REACT_APP_CASE_AUTH_SECURITY; // /auth
                const body = {
                    redirect_uri: window.location.href,
                    nonce: localStorage.getItem('nonce'),
                    state: localStorage.getItem('state')
                }
                const accessToken = await getAccessTokenSilently()
                const request = {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + accessToken
                    },
                    body: JSON.stringify(body)
                }
                console.log ('CaseCallback - call security api url=', url, 'body=', body, request )

                const res = await fetch(url, request);

                console.log ('CaseCallback security api - response =', res)

                if (!res.ok) {
                    console.log ('error fetching case token')
                    throw new Error(`Case token exchange failed: ${res.status}`);
                }

                const data = await res.json();


                console.log ('Callback data=', data)

                setCaseAccessToken(data?.access_token);
                setCaseTokenExpiry(now + Number(data?.expires_in))
                setCaseRefreshToken(data.refresh_token)

                //cleanup
                localStorage.removeItem('state');
                localStorage.removeItem('nonce');
                localStorage.removeItem('originalPath')

                console.log ('originalPath=', originalPath)
                history.replace( originalPath ? originalPath : "/");

            } catch (err) {

                //cleanup
                localStorage.removeItem('state');
                localStorage.removeItem('nonce');
                localStorage.removeItem('originalPath');

                console.error('Error in case callback:', err);
                setCaseTokenError('Error in case callback:' + err)

                history.replace( originalPath ? originalPath : "/");

            }
        };

        if (error) {
            setCaseTokenError('case callback error getting code ' + error)
            history.replace( originalPath ? originalPath : "/");
        } else if (code) {
            console.log ('Callback.jsx - got code, now call sec api and set case token')
            handleCaseCallback();

        } else {

            history.replace( originalPath ? originalPath : "/");
        }
    }, [history, setCaseAccessToken]);

    return (
        <React.Fragment>
            <LinearProgress style={{backgroundColor: progressBarColour}}/>
            <div style={{color: '#808080', fontSize: '0.75rem', fontWeight: '500', lineHeight: '24px', paddingLeft: '6px'}}>
                Processing authentication...
            </div>
        </React.Fragment>
    );
};

export default Callback;
